import React from "react";

const PDDPIIT = () => {
    return (
        <div className="w-full bg-gradient-to-br from-slate-900/80 to-slate-800/70 border border-cyan-500/20 rounded-2xl p-4 shadow-xl">
            <div className="flex flex-col items-center gap-4">
                <div className="w-full flex flex-col items-center">
                    <img
                        src="/assets/logo.png"
                        alt="Think5Whys Logo"
                        className="w-24 rounded-2xl border border-purple-500 shadow-lg"
                    />

                    <div className="mt-2 text-center text-sm lg:text-lg text-cyan-200 leading-relaxed">
                        🚀 Evolving DeepTech Venture
                    </div>
                </div>

                <div className="w-full text-center lg:text-left">
                    <p className="text-xs lg:text-sm text-gray-200 leading-relaxed">
                        🌍 Building <span className="text-cyan-300 font-semibold">Gen Z Digital Hustles & Jobs</span>
                    </p>
                    <p className="text-xs lg:text-sm text-gray-200 leading-relaxed">
                        🔥 To transform <span className="text-purple-300 font-semibold">Youth Energy</span> and a
                        mobile in hand into real digital economic value.
                    </p>                    
                    <p className="mt-3 text-xs lg:text-sm text-gray-300 leading-relaxed">
                        🎯 Target: <span className="text-yellow-300 font-semibold">1 Lakh Digital Franchises</span> (FY 2026–27)
                    </p>
                    <p className="mt-3 text-xs lg:text-sm text-gray-300 leading-relaxed">
                        💻 Remote Work From Home
                    </p>
                    <p className="mt-3 text-xs lg:text-sm text-pink-300 leading-relaxed">
                        🚺 Especially empowering women to build independent income.
                    </p>
                    <p className="mt-2 text-xs lg:text-sm text-green-300 leading-relaxed">
                        🤝 Full Support
                    </p>
                    <p className="mt-2 text-xs lg:text-sm text-green-300 leading-relaxed">
                        💳 Working Capital Credits
                    </p>
                </div>
                <div className="w-full flex flex-col items-center">
                    <img
                        src="/assets/startupindia_logo.webp"
                        alt="Startup India Logo"
                        className="w-24 rounded-2xl border border-purple-500 shadow-lg"
                    />

                    <div className="mt-2 text-center text-xs lg:text-sm text-cyan-200 leading-relaxed">
                        🏅 DPIIT Startup India Recognized Startup
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PDDPIIT;